import './RequestTypeText.css'

const RequestTypeText = ({ type }) => {
  return (
    <span className={`request-type-text ${type.toLowerCase()}`}>{type}</span>
  );
};

export default RequestTypeText;
